module.exports = __webpack_public_path__ + "img/grupo mandarin house.e2be6328.png";